import {Vehicle} from "@commons/models/domain/Vehicle";

export class VehicleTachoProcessor {
  setVehiclesTacho(updatedData: any, vehicle: Vehicle) {
    vehicle.Tacho = updatedData.Data;
  }
}
